import React from "react";
import styled from "styled-components";

import { currentLanguage } from "helpers";

import Button from "partials/Button";
import GridElement from "partials/GridElement";
import Image from "partials/Image";
import FavoriteButton from "partials/FavoriteButton";
import SmartLink from "partials/SmartLink";

import { getDate } from "./HandleDate";

import Arrow from "icons/ArrowIcon";

export const MobileCard = (props) => {
  const { item } = props;

  return (
    <Card key={item.id} className={props.className}>
      <SmartLink to={item.link}>
        <StyledImage
          image={item.acf.featured_image}
          ratio='5:4.4'
          background
        ></StyledImage>
      </SmartLink>
      <h3>{item.acf.item_name}</h3>
      <Grid>
        <GridElement colStart={1} colEnd={8} rowStart={1}>
          <ActivityInfo>
            <span>
              {getDate(item.acf.from_date).toUpperCase()} –{" "}
              {getDate(item.acf.to_date).toUpperCase()}
            </span>
            <span>•</span>
            <span>{`${item.acf.duration} ${
              currentLanguage() === "no" ? "TIMER" : "HOURS"
            }`}</span>
          </ActivityInfo>
        </GridElement>
        <GridElement colStart={1} colEnd={4} rowStart={2} align='center'>
          <Price>Per person NOK {item.acf.price}</Price>
        </GridElement>
        <GridElement colStart={5} colEnd={6} rowStart={2} align='center'>
          <SmartLink to={item.link}>
            <Button>
              <StyledArrow />
            </Button>
          </SmartLink>
        </GridElement>
        <GridElement colStart={7} colEnd={8} rowStart={2} align='center'>
          <FavoriteButton sort={item.type} item={item} />
        </GridElement>
      </Grid>
    </Card>
  );
};

export default MobileCard;

const Card = styled.div`
  width: 100%;

  h3 {
    width: 100%;
    background-color: ${(props) => props.theme.colors.negative};
    color: ${(props) => props.theme.colors.text};
    padding: ${(props) => props.theme.spacing.contentM} 0
      ${(props) => props.theme.spacing.contentS};
  }
`;

const StyledImage = styled(Image)`
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
    svg {
      opacity: 1;
    }
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
`;

const ActivityInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 25px;

  span {
    ${(props) => props.theme.p}
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;
    margin-right: 8px;
  }
`;

const Price = styled.span`
  ${(props) => props.theme.p}
  font-size: 14px;
  text-align: center;
`;

const StyledArrow = styled(Arrow)`
  fill: ${(props) => props.theme.colors.negative};
`;
